import { hotjar } from 'react-hotjar';
import queryString from 'query-string';
import Lang from '../lang/translations';
import ReactGA from 'react-ga4';
import TagManager from 'react-gtm-module';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import Resizer from 'react-image-file-resizer';
const config = require("./configServizi");



export default {
    getCountry,
    GetNavigation,
    setUser,
    postVisitedProfile,
    isToday,
    InitialSetup,
    scrollToBottom,
    randomTime,
    checkLandedTime,
    findLastIndex,
    updatePushToken,
    removePushToken,
    getCanaliNotifiche,
    canaliAttivi,
    isIOS,
    isAppInstallata,
    errorCodes,
    importOrder,
    importUpsale,
    importClick,
    getRegionsByCountry,
    getBrowserFingerprint,
    setFluxIdInitial,
    cancelOrder,
    setAnalyticsDimensions,
    setExternalScripts,
    randomNum,
    getCities,
    logToBackend,
    resettoUser,
    getBrowserVisibility,
    isValidDate,
    normalizeYear,
    formalizzaDataSignup,
    isProduction,
    showHook,
    showPopupgenerico,
    retargetingScripts,
    tryCharge,
    createToken,
    addExternalScriptToComponent,
    unsubUser,
    getTotalAngelInRegion,
    contentManagement,
    getCitiesByCountry,
    showPopuphook,
    updateNavigation,
    eventPost,
    contenuto_popop_pagamento,
    getPaymentGateway,
    getCDNfolder,
    kpiPanel,
    rendiDataLeggibile,
    set_seme,
    uploadFotoProfilo,
    isQualityMessage,
    trovaRateplan
  };


 

  function errorCodes(code){

    const codeNumber = code.message.split("-");
    console.log("Error code",codeNumber,code)

    switch(codeNumber[1]) {
        case "1000":
          return Lang( {"w": "email_esistente","page": "errorHandler"} )
        case "1001":
          return Lang( {"w": "utente_non_trovato","page": "errorHandler"} )
        case "1003":
          return Lang( {"w": "fingerprint","page": "errorHandler","placeholders":{email:code.userMail}} )
        case "1004":
          return Lang( {"w": "email_non_valida","page": "errorHandler"} )
        case "1005":
          return Lang( {"w": "email_vietata","page": "errorHandler"} )
        case "1006":
          window.location.replace(code.userMail)
        case "1007":
          return Lang( {"w": "troppi_tentativi","page": "errorHandler"} )
        case "1008":
          return Lang( {"w": "account_disabilitato","page": "errorHandler"} )
        case "1009":
          return Lang( {"w": "welcome_gia_inviata","page": "errorHandler"} )
        default:
          return Lang( {"w": "qualcosa_storto","page": "errorHandler"} )
      } 
}


function set_seme(seme,context){

  if(seme){
    localStorage.setItem("dispenserSeed",seme)
    localStorage.setItem("dispenserSeedTime",new Date().getTime())
    console.log("Setto seme",seme)
    context.setSeme(seme)
    return seme
  }

  let seed = localStorage.getItem("dispenserSeed")
  const seedTime = localStorage.getItem("dispenserSeedTime")
  const now = new Date().getTime()
  if(!seed || (seedTime && now - seedTime > 1800000) ){
    seed = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    localStorage.setItem("dispenserSeed",seed)
    localStorage.setItem("dispenserSeedTime",now)
  }
  return seed;
}


function enableUserPhotoPopup(user){
  if(user.flusso.foto_obbligatoria == true && user.lastActivity == null && user.imageName?.length == 0 ){
    return true
  }
  return false
}

  function getCountry(fluxId){
    const domain = window.location.hostname;
    document.title =  config.servizi[domain].title;


    /*if(fluxId){
      if(config.servizi[domain].country != browserLanguage && fluxId == "0000"){
        console.log("Setto dissonanza lingua")
        return "en"
      }
    }*/
    
    return config.servizi[domain].country;
}


function getCDNfolder(){

  //--- il dafault folder è quello che viene usato quando ho solo l'angelId 
  //--- il collection folder è quello che viene usato quando ho l'angelId_{numero_foto}

  const domain = window.location.hostname;
  const collection_folder = config.servizi[domain].cartella_foto_collection
  const default_folder = config.servizi[domain].cartella_foto_default
  return {collection_folder,default_folder}
}


function isToday(someDate){
    const today = new Date()
    return someDate.getDate() === today.getDate() &&
      someDate.getMonth() === today.getMonth() &&
      someDate.getFullYear() === today.getFullYear()

}


function randomTime(){
	var min = 20000;
	var max = 40000;
	min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
}


function scrollToBottom(){
  const marker = document.getElementById('bottom-chat-marker');
  if (marker) {
    marker.scrollIntoView({ behavior: 'instant', block: 'end' });
  } else {
    // Fallback alla vecchia logica se il marker non viene trovato
    const chatHeight = document.getElementById('chatHeight');
    const chatArea = document.getElementById('chatArea');

    if(chatHeight != null){
        if(window.innerWidth < 1000){
          window.scrollTo({
            top: document.documentElement.scrollHeight,
            behavior: 'instant'
          });
        } else if (chatArea) {
          chatArea.scrollTop = chatArea.scrollHeight;
        }
    }
  }
}

async function setUser(user,context,verifyUser,togliHook){

    localStorage.setItem('trackerId', user.clickid);

      if(user.token){
        localStorage.setItem('token',user.token)
      }

      context.setCreditiMessaggi(user.flusso.messaggiFree)
      context.setCreditiIcebreaker(user.flusso.creditiIcebreaker)
      localStorage.setItem('like',user.flusso.creditiLike)
      context.SetMessaggiNonLetti(1)
      
      context.setFlusso(user.flusso)
      context.setSearchRegion(user.region)
      context.setSearchCity(user.city)
      context.setUserEmail(user.email)
 
      context.setFluxId(user.fluxId)
      context.setPremiumLevel(user.premiumLevel)

      context.setUser_info(user)

      if(togliHook){
        context.setModalShowHook(false)
      }
      
      context.setStatoSignupForm(true)

      if(verifyUser){

        context.setVerifiedUser(true)

        if(user.confirmed_email){
          context.processoDiNotifica()
        }
      }

      if(user.imageName){
        localStorage.setItem('avatar',process.env.REACT_APP_APIADDRESS+"/uploads/"+user.imageName)
      }

      if(user.remarketing_clickid){
        localStorage.setItem('remarketing_clickid',user.remarketing_clickid)
      }

      const rateplan_default = await scegliRatePlanDiDefault(user.flusso.rateplans, user.premiumLevel, user.fluxId)

      context.setRateplanScelto(rateplan_default)
      context.setValoreMessaggio(user.flusso.valoreMessaggio)

      if(user.customerId){
        context.setCustomerId(user.customerId)
      }

      //---- cerco se ci sono token salvati
      //console.log("cardTokens",user.cardTokens)
      const token = user.cardTokens.some((el) => el.cardToken?.length > 0)
      
      if(token){
        console.log("actonfile",user.cardTokens.some((el) => el.cardToken?.length > 0))
        context.setActonfile(token)
      }

      if (localStorage.getItem('ccare') === "true") {
        context.setCcare_session(true)
        console.log("Sessione ccare attivata")
      }

      if(user.additionalInfo){
        if(user.additionalInfo.aff_payment_url){
          context.setAff_payment_url(user.additionalInfo.aff_payment_url)
        }
      }

      const isMobile = window.innerWidth <= 500 ? true : false;

      if(isMobile){
        if(user.pushToken == "" && user.telegramId == null){
         // messaggioAttivaNotifiche(context)
        }
      }else{
        if(user.pushToken == ""){
         // messaggioAttivaNotifiche(context)
        }
      }


}

// Cerca il rateplan più adatto nella collection dedicata.
// Riceve un insieme di criteri e li tenta in cascata dal più specifico al più generico:
// id → tipologia_rateplan → tipologia_utente → country
// Restituisce il primo documento trovato, o null se nessun criterio matcha.
// La logica di quale criterio passare è responsabilità del chiamante, non di questa funzione.
async function trovaRateplan({ id, tipologia_rateplan, tipologia_utente, country } = {}) {
  const token = localStorage.getItem("token");
  const base = process.env.REACT_APP_APIADDRESS + "/rateplan/find";

  try {
    const res = await fetch(base, {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      },
      body: JSON.stringify({ id, tipologia_rateplan, tipologia_utente, country })
    });
    if (!res.ok) return null;
    return await res.json();
  } catch (err) {
    console.error("Error fetching rateplan:", err.message);
    return null;
  }
}



async function scegliRatePlanDiDefault(rateplans,premiumLevel,fluxid){
console.log("Scegli rateplan di default",rateplans)

    if(fluxid === "0000"){
     const rp =  await trovaRateplan({id: rateplans.compliant.id });
     //scelgo quello con evidenziato = true altrimenti il primo della lista
     return rp.plans.find(plan => plan.evidenziato) || rp.plans[0];
    }else{
      if(premiumLevel === 0){
        const rp = await trovaRateplan({id: rateplans.free.id});
        return rp.plans.find(plan => plan.evidenziato) || rp.plans[0];
      }else{

          const rp = await trovaRateplan({id: rateplans.premium.id});
          return rp.plans.find(plan => plan.evidenziato) || rp.plans[0];
        }

      }
    }




async function getPaymentGateway(clickid){
  return await fetch(process.env.REACT_APP_PAY+"/pay_rules/get_pay_rules",{ 
    method: 'post', 
    body: JSON.stringify({clickid: clickid}),
  })
  .then(response => response.json())
  .then(risposta => {
      return risposta
  })
}



function messaggioAttivaNotifiche(context){
  const testoTooltip = Lang( {"w": "attiva_notifiche","page": "tooltip"})
  const titoloTooltip = Lang( {"w": "titolo_attiva_notifiche","page": "tooltip"})
  const bottone = Lang( {"w": "bottone_attiva_notifiche","page": "tooltip"})
  
  setTimeout(() => {
    
    context.setTooltip({variant:"danger",visible:true,title:titoloTooltip,text:testoTooltip,button:bottone,redirect:"/activeNotifications",autoClose:false,tipo:"messaggioGenerico"})
   
  },30000)
}


async function getBrowserFingerprint(){
 
    //00462ad6d0118ffd28270008f9b4bf33 -- firefox
    //00462ad6d0118ffd28270008f9b4bf33 -- chrome
    //
    const fp = await FingerprintJS.load();
    const result = await fp.get();
  
    const visitorId = result.visitorId;
    localStorage.setItem('fingerprint', visitorId);

    
 
}


function showHook(provenienza,angel,context,navigate){

  //const path = buildAnaliticsModalEvent(provenienza,angel)
  //ReactGA.modalview(path)
console.log("Mostro hook",provenienza,angel)

  if(context.flusso.verificaEta){
    angel ? context.setHeaderAbbonamento({tipo:provenienza,angelName:angel.screenName,angelId:angel.id}) : context.setHeaderAbbonamento({tipo:provenienza,angelName:null,angelId:null})
    navigate('/vip_plan/cred')
  }else{
    angel ? context.setHeaderAbbonamento({tipo:provenienza,angelName:angel.screenName,angelId:angel.id}) : context.setHeaderAbbonamento({tipo:provenienza,angelName:null,angelId:null})
    context.setPopupHook({provenienza:provenienza,angel:angel})
    context.setModalShowHook(true);
  }	
  
}


function showPopupgenerico(provenienza,context,contenuto){

    context.setPopupGenerico({provenienza:provenienza,contenuto:contenuto})
    context.setModalShowPopupGenerico(true)

}


function showPopuphook(provenienza,context,contenuto){

  context.setPopupHook({provenienza:provenienza,contenuto:contenuto})
  context.setModalShowHook(true)

}


function contentManagement(result){

  
  var descrizione = ""
  var titolo = ""
  var icona = ""
  var color = "#840000"
  var redirect =  "/vip_plan/cred"
  var bottoni = null
  var testo_bottone = Lang( {"w": "tasto_riprova","page": "creditCardForm","var":true} )
  switch(result) {
    case "invalid_cvc":
      descrizione = Lang( {"w": "cvv_errato","page": "creditCardForm","var":true} )
      titolo = Lang( {"w": "titolo_cvv","page": "creditCardForm","var":true} )
      icona = "cvv.svg"
      return {titolo:titolo,descrizione:descrizione,icona:icona,color:color,redirect:redirect,testo_bottone:testo_bottone}
    case "insufficient_funds":
      descrizione = Lang( {"w": "fondi_insufficenti","page": "creditCardForm","var":true} )
      titolo = Lang( {"w": "titolo_fondi_insufficenti","page": "creditCardForm","var":true} )
      icona = "declined.svg"
      return {titolo:titolo,descrizione:descrizione,icona:icona,color:color,redirect:redirect,testo_bottone:testo_bottone}
    case "lost_or_stolen":
      descrizione = Lang( {"w": "persa_rubata","page": "creditCardForm","var":true} )
      titolo = Lang( {"w": "titolo_persa_rubata","page": "creditCardForm","var":true} )
      icona = "declined.svg"
      return {titolo:titolo,descrizione:descrizione,icona:icona,color:color,redirect:redirect,testo_bottone:testo_bottone}
    case "invalid_expiry_month":
    case "invalid_expiry_year":
    case "expired_card":
      descrizione = Lang( {"w": "scaduta","page": "creditCardForm","var":true} )
      titolo = Lang( {"w": "titolo_generico","page": "creditCardForm","var":true} )
      icona = "declined.svg"
      return {titolo:titolo,descrizione:descrizione,icona:icona,color:color,redirect:redirect,testo_bottone:testo_bottone}
    case "This card has already declined. Please try a new card.":
      descrizione = Lang( {"w": "gia_processata","page": "creditCardForm","var":true} )
      icona = "declined.svg"
      return {titolo:titolo,descrizione:descrizione,icona:icona,color:color,redirect:redirect,testo_bottone:testo_bottone}
    case "change_method":
      descrizione = Lang( {"w": "cambia_metodo_pagamento","page": "creditCardForm","var":true} )
      icona = "declined.svg"
      return {titolo:titolo,descrizione:descrizione,icona:icona,color:color,redirect:redirect,testo_bottone:testo_bottone}
    case "avoid_duplicate_transaction":
      titolo = Lang( {"w": "pagamento_in_corso","page": "creditCardForm","var":true,"var":true} )
      descrizione = Lang( {"w": "attendi_un_minuto","page": "creditCardForm","var":true} )
      icona = "clessidra.svg"
      redirect =  "/chats"
      bottoni = [
        {redirect: true, onclick : "window.location.replace('/chats')"}
      ]
      testo_bottone = Lang( {"w": "continua","page": "creditCardForm","var":true} )
      return {titolo:titolo,descrizione:descrizione,icona:icona,color:color,redirect:redirect,testo_bottone:testo_bottone}
    case "processing_error":
    case "card_declined":
      descrizione = Lang( {"w": "cambia_carta","page": "creditCardForm","var":true} )
      titolo = Lang( {"w": "titolo_generico","page": "creditCardForm","var":true} )
      icona = "declined.svg"
      return {titolo:titolo,descrizione:descrizione,icona:icona,color:color,redirect:redirect,testo_bottone:testo_bottone}
    case "warning":
      descrizione = Lang( {"w": "verifica_fallita","page": "creditCardForm","var":true} )
      titolo = Lang( {"w": "titolo_verifica_fallita","page": "creditCardForm","var":true} )
      icona = "declined.svg"
      return {titolo:titolo,descrizione:descrizione,icona:icona,color:color,redirect:redirect,testo_bottone:testo_bottone}
    case "invalid_number":
      descrizione = Lang( {"w": "numero_carta_non_valido","page": "creditCardForm","var":true} )
      titolo = Lang( {"w": "titolo_generico","page": "creditCardForm","var":true} )
      icona = "declined.svg"
      return {titolo:titolo,descrizione:descrizione,icona:icona,color:color,redirect:redirect,testo_bottone:testo_bottone}
    case "payment_canceled":
      descrizione = Lang( {"w": "descrizione_canceled","page": "creditCardForm","var":true} )
      titolo = Lang( {"w": "titolo_canceled","page": "creditCardForm","var":true} )
      icona = "declined.svg"
      return {titolo:titolo,descrizione:descrizione,icona:icona,color:color,redirect:redirect,testo_bottone:testo_bottone}
    case "address blacklisted":
      descrizione = Lang( {"w": "blacklisted","page": "creditCardForm","var":true} )
      return descrizione
    case "riprova":
    case "pin_required":
    case "3ds":
      descrizione = Lang( {"w": "riprova","page": "creditCardForm","var":true,"var":true} )
      titolo = Lang( {"w": "titolo_riprova","page": "creditCardForm","var":true,"var":true} )
      icona = "declined.svg"
      return {titolo:titolo,descrizione:descrizione,icona:icona,color:color,redirect:redirect,testo_bottone:testo_bottone}
    case "authentication_required":
      descrizione = Lang( {"w": "riprova","page": "creditCardForm","var":true} )
    case "generico":
      descrizione = Lang( {"w": "generico","page": "creditCardForm","var":true} )
      titolo = Lang( {"w": "titolo_generico","page": "creditCardForm","var":true} )
      icona = "declined.svg"
      return {titolo:titolo,descrizione:descrizione,icona:icona,color:color,redirect:redirect,testo_bottone:testo_bottone}
    case "suspected_fraud":
      descrizione = Lang( {"w": "generico","page": "creditCardForm","var":true} )
      titolo = Lang( {"w": "titolo_generico","page": "creditCardForm","var":true} )
      icona = "declined.svg"
      return {titolo:titolo,descrizione:descrizione,icona:icona,color:color,redirect:redirect,testo_bottone:testo_bottone}
    case "problemi_api":
      descrizione = Lang( {"w": "descrizione_problemi_api","page": "creditCardForm","var":true} )
      titolo = Lang( {"w": "titolo_problemi_api","page": "creditCardForm","var":true} )
      icona = "declined.svg"
      return {titolo:titolo,descrizione:descrizione,icona:icona,color:color,redirect:redirect,testo_bottone:testo_bottone}
    case "pending":
      descrizione = Lang( {"w": "generico","page": "creditCardForm","var":true} )
      titolo = Lang( {"w": "titolo_pending","page": "creditCardForm","var":true} )
      icona = "declined.svg"
      return {titolo:titolo,descrizione:descrizione,icona:icona,color:color,redirect:redirect,testo_bottone:testo_bottone}
    case "open":
      descrizione = Lang( {"w": "open","page": "creditCardForm","var":true} )
      titolo = Lang( {"w": "titolo_open","page": "creditCardForm","var":true} )
      icona = "clessidra.svg"
      return {titolo:titolo,descrizione:descrizione,icona:icona,color:color,redirect:redirect,testo_bottone:testo_bottone}
    case "waiting":
      descrizione = Lang( {"w": "waiting","page": "creditCardForm","var":true} )
      titolo = Lang( {"w": "titolo_waiting","page": "creditCardForm","var":true} )
      icona = "spinner.svg"
      testo_bottone = Lang({ "w": "continua", "page": "creditCardForm", "var": true })
      return {titolo:titolo,descrizione:descrizione,icona:icona,color:color,redirect:redirect,testo_bottone:testo_bottone}
    case "promo":
      try{
      console.log("dentro in promo")
      const messaggio = Lang({ "w": "descrizione_pacchettone","page": "creditCardForm","var":true} )
      titolo = Lang({ "w": "titolo_pacchettone","page": "creditCardForm","var":true} )
      const prendine_un_altro = Lang({ "w": "prendine_un_altro","page": "creditCardForm","var":true} )
      testo_bottone = Lang( {"w": "continua","page": "creditCardForm","var":true} )
      bottoni = [
        { redirect: false, testo: testo_bottone }
      ]
      return { titolo, messaggio, testo_bottone, prendine_un_altro }
      }catch(error){
        console.log("Errore nella gestione del promo",error)
       
      }
    case "success":
      descrizione = Lang( {"w": "success","page": "creditCardForm","var":true} )
      titolo = Lang( {"w": "titolo_success","page": "creditCardForm","var":true} )
      icona = "ok.svg"
      color="#067a15"
      redirect =  "/chats"
      bottoni = [
        {redirect: true, onclick : "window.location.replace('/chats')"}
      ]
      testo_bottone = Lang( {"w": "continua","page": "creditCardForm","var":true} )
      return {titolo:titolo,descrizione:descrizione,icona:icona,color:color,redirect:redirect,testo_bottone:testo_bottone}
    default:
      console.log("Errore non gestito")
      descrizione = Lang( {"w": "generico","page": "creditCardForm","var":true} )
      titolo = Lang( {"w": "titolo_generico","page": "creditCardForm","var":true} )
      icona = "declined.svg"
      return {titolo:titolo,descrizione:descrizione,icona:icona,color:color,redirect:redirect,testo_bottone:testo_bottone}
  }


}

const _resizeFile = (file) => new Promise(resolve => {
    Resizer.imageFileResizer(file, 1000, 1000, 'JPEG', 100, 0, uri => resolve(uri), 'file');
});

async function uploadFotoProfilo(file, moderazioneFoto) {
    const allowed = ['image/jpeg', 'image/gif', 'image/png', 'image/svg+xml'];
    if (!allowed.includes(file[0].type)) {
        return { status: 'invalid_type' };
    }
    try {
        const resizedImage = await _resizeFile(file[0]);
        const token = localStorage.getItem('token');
        const trackerId = localStorage.getItem('trackerId');
        const formData = new FormData();
        formData.append('avatar', resizedImage);
        if (moderazioneFoto) formData.append('moderazione_foto', JSON.stringify(moderazioneFoto));

        const response = await fetch(process.env.REACT_APP_APIADDRESS + '/upload/' + trackerId, {
            method: 'post',
            body: formData,
            headers: { 'Authorization': 'Bearer ' + token }
        });

        if (response.status === 422) return { status: 'rejected' };

        const data = await response.json();
        const newPath = data.data[0].path;
        const finalAvatarUrl = newPath.startsWith('http')
            ? newPath
            : config.servizi[window.location.hostname].url_foto_utente + '/uploads/' + newPath;
        localStorage.setItem('avatar', finalAvatarUrl);

        return { status: 'ok', data: data.data, avatarUrl: finalAvatarUrl };
    } catch (err) {
        return { status: 'error' };
    }
}


function contenuto_popop_pagamento(risposta){
  const contenuto = contentManagement(risposta)
  console.log("contenuto",contenuto)

  const iconMapping = {
    "clessidra.svg": require('./icons/clessidra.svg').default,
    "cvv.svg": require('./icons/cvv.svg').default,
    "declined.svg": require('./icons/declined.svg').default,
    "ok.svg": require('./icons/ok.svg').default,
    "spinner.svg": require('./icons/spinner.svg').default,
  };

  return {
      ...contenuto,
      descrizione: contenuto.titolo,
      icona: contenuto.icona ? (iconMapping[contenuto.icona] || null) : null,
      messaggio:contenuto.descrizione,
      colore:contenuto.color,
      bottoni:[
          {
              redirect:contenuto.redirect,
              testo:contenuto.testo_bottone
          }
      ],
      rateplan: contenuto.rateplan ? contenuto.rateplan : null,

  }
}





async function kpiPanel(context,nome_evento,valore_evento,metadata,unica = null,canon = null){
  try {

      if (!context.user_info || (typeof context.user_info === "object" && Object.keys(context.user_info).length === 0)) {
          return;
      }
      
      if(!isProduction()){
        //console.log("KPIpanel disabilitato in locale",context.user_info.clickid,nome_evento,valore_evento)
        return
      }


      var url = "https://kpi.mob1track.com/log/event"

      const body = {
          clickid: localStorage.getItem('trackerId'),
          service: window.location.hostname,
          nome_evento: nome_evento,
          valore_evento: valore_evento,
          premiumLevel: context.user_info.premiumLevel > 0 ? "premium" : "free",
          flux : context.user_info.fluxId,
          email: context.user_info.email,
          country: context.user_info.country,
          ua: context.user_info.ua,
          unica:unica,
          metadata:metadata,
          user_id: context.user_info.marketing_info?.external_id,
          canon: canon
      }

      fetch(url, {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json'
          },
          body: JSON.stringify(body)
      })
      .then(res =>  {
          
      }).catch(err=>{
          console.log("ERRORE KPIpanel",err)
      })
  }catch (error) {
      console.log("ERRORE kpiPanel",error)
  }

}


function retargetingScripts(type){

    /* --------- LEAD PIXELS ------------- */

    if(type == "lead"){
      var scripts = [
        { url : "https://a.exoclick.com/tag_gen.js", data: {name: "data-goal",value:"87e9345183a4d8ed7a85fbcac1204d54"}, tipo: "script", network:"exo" },
        { url : "//tsyndicate.com/api/v1/retargeting/set/8639d906-d76a-45e7-8c99-c0f3d063eaee", tipo: "image" , network: "trs" },
        { url : "https://ads.traffichunt.com/adv_ret/?adv_pixel_id=914&nid=3", tipo: "image" , network: "trhunt" }
      ]
    }
    if(type == "tentativo"){
      var scripts = [
        { url : "https://a.exoclick.com/tag_gen.js", data: {name: "data-goal",value:"4198673960721d98d5c586b0e4513c70"}, tipo: "script", network:"exo" },
        { url : "//tsyndicate.com/api/v1/retargeting/set/06e33e98-6352-4bde-a3da-7080f389d565", tipo: "image" , network: "trs" },
        { url : "https://ads.traffichunt.com/adv_ret/?adv_pixel_id=915&nid=3", tipo: "image" , network: "trhunt" }
      ]
    }


    var element = null

      for(let i=0;i<scripts.length;i++){
          if(scripts[i].tipo == "script"){
            element = document.createElement('script')
            element.src = scripts[i].url
            if(scripts[i].data){
              element.setAttribute(scripts[i].data.name, scripts[i].data.value)
            }
            element.async = true
          }
          if(scripts[i].tipo == "image"){
            element = document.createElement('img')
            element.src = scripts[i].url
            element.width = "0"
            element.height = "0"
          }
          document.body.appendChild(element);
      }

    

}



function buildAnaliticsModalEvent(provenienza,angel){
  var path = ""
  switch(provenienza) {
    case "fine_crediti":
      path = '/hook/fine_crediti_messaggi'
      break;
    case "file_like":
      path = '/hook/fine_like/'+angel.id
      break;
    case "paginazione":
      path = '/hook/paginazione/'
      break;
    case "profilo_bloccato":
      path = '/hook/profilo_bloccato/'+angel.id
      break;
    case "blurred":
      path = '/hook/messaggio_offuscato/'
      break;
    case "cambia_regione":
      path = '/hook/cambia_regione/'
      break;
    case "utente_premium":
      path = '/hook/profilo_bloccato/'+angel.id
      break;
    case "utente_premium_compliant":
      path = '/hook/profilo_bloccato/'+angel.id
      break;
    default:
      path = '/hook/errore'

    
  } 
  return path
}


function updateNavigation(context,element,value){
  var newNavigation = context.navigation
  //newNavigation[element] = value
  console.log(typeof newNavigation[element])
  //context.setNavigation(newNavigation)
}


async function GetNavigation(trackerId,context) {
  
    if(trackerId === 'undefined' || typeof trackerId === 'undefined'){
        trackerId = "cazzi";
    }
    var country = localStorage.getItem('country');
    var token = localStorage.getItem('token');
    
    if(!country){
        country = await getCountry();
        localStorage.setItem('country', country);
    }
      fetch(process.env.REACT_APP_APIADDRESS+"/get/all/"+trackerId,{ 
			method: 'get', 
			headers: {
			  'Authorization': 'Bearer '+ token
			}
		})
            .then(response => response.json())
            .then(risposta => {
                
                localStorage.setItem('trackerId', trackerId);
                localStorage.setItem('profiliVisitati', risposta.navigation.profiliVisitati.toString());

                //--- Conto le notifiche non lette
                var convTemp = [];
                var nonLette = 0;
                
               
               
                localStorage.setItem('messaggiNonLetti',risposta.undreadedMessages)
                context.SetMessaggiNonLetti(risposta.undreadedMessages)
                var crediti = risposta.navigation.creditiMessaggi + risposta.navigation.creditiMessaggiAbbonamento

                //context.setNavigation(risposta)
                
                context.setCreditiMessaggi(crediti)
                context.setCreditiIcebreaker(risposta.navigation.creditiIcebreaker)

           
                context.setProfiliLike(risposta.profiliLike)
                

                //--------------



                //gtag('set', {'user_id': trackerId}); // Imposta l'ID utente utilizzando l'ID utente della persona che ha eseguito l'accesso.
            }) 
            .catch((error) => {
              console.error(error);
            });			
} 





async function getTotalAngelInRegion(country,region){
  return await fetch(process.env.REACT_APP_DISPENSER+"/totalRegion", {
    method: 'POST',
    headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
    },
    body: JSON.stringify({"country" : country, "region":region})
  })
  .then(response => response.json())
  .then(response => response)
}


async function logToBackend(subject,messaggio){
  const oggetto = {
    subject:subject,
    messaggio:messaggio
  }
  return await fetch(process.env.REACT_APP_APIADDRESS+"/log/client",{ 
    method: 'post', 
    headers: {
      'Accept': 'application/json, text/plain, */*',
			'Content-Type': 'application/json'
    },
    body: JSON.stringify(oggetto)
  }).then(()=>{return true})
  .catch((err) => {
    console.log("Problemi con logToBackend",err.message)
  })
}



async function eventPost(clickid,angelId,type){
  const oggetto = {
    clickid:clickid,
    angelId:angelId,
    type:type
  }
  return await fetch(process.env.REACT_APP_APIADDRESS+"/log/event",{ 
    method: 'post', 
    headers: {
      'Accept': 'application/json, text/plain, */*',
			'Content-Type': 'application/json'
    },
    body: JSON.stringify(oggetto)
  }).then(()=>{return true})
  .catch((err) => {
    console.log("Problemi con logEvent",err.message)
  })
}


async function postVisitedProfile(angelId) {
  var token = localStorage.getItem('token');
  var trackerId = localStorage.getItem('trackerId');
  
  const tmpObject = {angelId: angelId,trackerId:trackerId};
  fetch(process.env.REACT_APP_APIADDRESS+"/collect/visited",{ 
    method: 'post', 
    headers: {
      'Accept': 'application/json, text/plain, */*',
			'Content-Type': 'application/json',
      'Authorization': 'Bearer '+ token
    },
    body: JSON.stringify(tmpObject)
  })
}


function checkLandedTime(){
  if(localStorage.getItem('landedTime') === null || localStorage.getItem('landedTime') === ''){
    localStorage.setItem('landedTime', new Date());
  }else{
    var landedTime = new Date(localStorage.getItem('landedTime'));
    const diffDays = Math.floor((landedTime - new Date()) / (1000 * 60 * 60 * 24)) //Calcolo della differenza in giorni
    const diffMinutes = Math.floor((new Date() - landedTime) / (1000 * 60)); // Calcolo della differenza in minuti

    
    if(diffDays < -1){
      localStorage.setItem('landedTime', new Date());
    }

    //se è maggiore di 10 minuti
    if(diffMinutes > 10){
      localStorage.setItem('landedTime', new Date());
    }
  }
}

function setFluxIdInitial(){
   // *** Setto il flux id in caso di nuovo arrivo
   const query = queryString.parse(window.location.search);
   const page = window.location.pathname;
   var fluxId = query.fluxid || query.fluxId ;
   var tid = query.tid
   const domain = window.location.hostname;
 
   if(fluxId){
     return fluxId
   }else{
     // *** se non c'è nella url e sono da home metto compliant
     if(page === "/" || page === "/signup"){
        if(tid){
          return config.servizi[domain].default_fluxid
        }
      return "0000"
     }else{
       //*** se non sono in home metto fluxid di ricaduta
       return config.servizi[domain].default_fluxid
     }
     
   }
}


async function getCities(name){
  const country = localStorage.getItem('country')
  return await fetch(process.env.REACT_APP_APIADDRESS+"/get/city/"+country+"/"+name)
    .then(res=>{
      return res
    })

}


function resettoUser(){
  localStorage.removeItem('trackerId')
  localStorage.removeItem('kcampaign')
  localStorage.removeItem('city')
  localStorage.removeItem('avaibleUsers')
  localStorage.removeItem('region')
  localStorage.removeItem('ip')
  localStorage.removeItem('source')
  localStorage.removeItem('country')
  localStorage.removeItem('vm')
}


async function InitialSetup(context){

  // *** Setto il trackerId in caso di nuovo arrivo
  const query = queryString.parse(window.location.search);
  const domain = window.location.hostname;
  var trackerId = query.tid;
  
   //+++ se non lo trovo sulla url
  if(typeof trackerId==='undefined'){
    //+++ guardo se c'è nel local storage
    if(localStorage.getItem('trackerId') === null || localStorage.getItem('trackerId') === ''){
      //+++ se non lo trovo neanche nel local storage lo genero
      trackerId = Math.random().toString(36).slice(2);
      localStorage.setItem('trackerId', trackerId)
    }else{
      //+++ se è nel local storage lo prelevo
      trackerId = localStorage.getItem('trackerId')
    }
  }else{
    //+++ se lo trovo sulla url guardo se c'era già anche nel local storage
    if(localStorage.getItem('trackerId') === null || localStorage.getItem('trackerId') === ''){
      //+++ se non è nel local storage setto quello della url
      localStorage.setItem('trackerId', trackerId)
    }else{
      //++comparo se quello della url è uguale a quello del local storage
      var clickIdLocalStorage = localStorage.getItem('trackerId')
      var res = clickIdLocalStorage.localeCompare(trackerId)
      //+++ se è uguale
      if(res === 0){
        trackerId = localStorage.getItem('trackerId')
      }else{
        //+++ altrimenti prendo quello del local storage
        localStorage.setItem('trackerId', trackerId)
      }
    }
  }

      var campid = query.campid;
      if(campid){
        localStorage.setItem('campid', campid);
      }
  
        // *** Setto la region in caso di nuovo arrivo
      var ip = query.ip;
      if(ip){
        localStorage.setItem('ip', ip);
      }else if(config.servizi[domain].affiliation){
        const clientInfo = await getIp()
        localStorage.setItem('ip', clientInfo.ip);
        localStorage.setItem('ua', clientInfo.ua);
      }
      
      var source = query.src;
      
      if(source){
        localStorage.setItem('source', source);
      }else{
        source = localStorage.getItem('source');
        if(!source){
          source = "direct";
          localStorage.setItem('source', "direct");
        }
      }
      
      const country=getCountry(context.fluxId);
      if(country){
        localStorage.setItem('country', country);
      }

      
      localStorage.removeItem("notificheInPending")

      setAnalyticsDimensions(trackerId,source,country,context.fluxId)
 
}


async function getIp(){

    return await fetch("https://tracker.trkmyclick.com/getIp.php")
    .then(response => response.json())

}


function randomNum(min,max){
	min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
}


function isProduction(){
  if( window.location.hostname === 'localhost' || window.location.hostname === 'staging.yatequiero.com'){
    return false
  }else{
    return true
  }
}


function getBrowserVisibility(){
  var hidden, visibilityChange;
  if (typeof document.hidden !== "undefined") { // Opera 12.10 and Firefox 18 and later support
    hidden = "hidden";
    visibilityChange = "visibilitychange";
  } else if (typeof document.msHidden !== "undefined") {
    hidden = "msHidden";
    visibilityChange = "msvisibilitychange";
  } else if (typeof document.webkitHidden !== "undefined") {
    hidden = "webkitHidden";
    visibilityChange = "webkitvisibilitychange";
  }

  const obj = {hidden:hidden,visibilityChange:visibilityChange}
  return obj

}


function setAnalyticsDimensions(trackerId,source,country,fluxId,signup){
  /*
  if(isProduction()){
      ReactGA.initialize('UA-167647038-1', {
        gaOptions: {
          userId: trackerId
        }
      })
      ReactGA.set({ userId: trackerId });
      ReactGA.set({ dimension1: trackerId }) //trackerId
      ReactGA.set({ dimension2: source }) //source
      ReactGA.set({ dimension3: window.location.hostname }) //servizio
      ReactGA.set({ dimension4: country }) //country
      ReactGA.set({ dimension6: fluxId }) //fluid*/

  /*
      if(signup){
        var signupDate = this.formalizzaDataSignup()
        ReactGA.set({ dimension5: signupDate }) //signupDate
				ReactGA.set({ dimension7: true }) //signup
				ReactGA.event({ category: 'User',action: 'Signup'})
      }
     
  }*/
}


function setExternalScripts(){

  const domain = window.location.hostname;
  
 

  if(isProduction()){

    
        // Inizializza Google Tag Manager
    const gtmId = config.servizi[domain]?.googleTagManager;
    if (gtmId) {
        TagManager.initialize({
            gtmId: gtmId,
            dataLayer: {
                clickid: localStorage.getItem("trackerId"),
                domain: window.location.hostname
            }
        });
    }

   

    //hotjar.initialize(3618073, 6);
  }
}






function addExternalScriptToComponent(url,firstUpdate,data){

  if(firstUpdate && isProduction()){
    const script = window.document.createElement('script');
    script.src = url;
    script.async = true;
    for (const [key, value] of Object.entries(data)) {
      script.setAttribute(key, value);
    }
    window.document.body.appendChild(script);
  }
  
}


function updatePushToken(pushToken){
  var trackerId = localStorage.getItem('trackerId');
  var token = localStorage.getItem('token');
  const tmpObject = {pushToken: pushToken,clickid:trackerId};
  fetch(process.env.REACT_APP_APIADDRESS+"/users/pushToken",{ 
    method: 'post', 
    headers: {
      'Accept': 'application/json, text/plain, */*',
			'Content-Type': 'application/json',
      'Authorization': 'Bearer '+ token
    },
    body: JSON.stringify(tmpObject)
  })
}

// toglie dall'utente il token push di questo browser; lancia se il backend non risponde ok
async function removePushToken(pushToken){
  var token = localStorage.getItem('token');
  const res = await fetch(process.env.REACT_APP_APIADDRESS+"/users/pushToken/remove",{
    method: 'post',
    headers: {
      'Accept': 'application/json, text/plain, */*',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+ token
    },
    body: JSON.stringify({pushToken: pushToken})
  })
  if(!res.ok) throw new Error('HTTP ' + res.status);
}

// canali di notifica attivi dell'utente: { push: numero dispositivi, telegram: true/false }; null se il backend non risponde
async function getCanaliNotifiche(){
  try{
    var token = localStorage.getItem('token');
    const res = await fetch(process.env.REACT_APP_APIADDRESS+"/users/canaliNotifiche",{
      headers: {
        'Accept': 'application/json, text/plain, */*',
        'Authorization': 'Bearer '+ token
      }
    })
    if(!res.ok) return null;
    return await res.json();
  }catch(err){
    return null;
  }
}

// true se l'account ha almeno un canale attivo (push su un dispositivo o telegram); user_info e' quello ricevuto al login
function canaliAttivi(user_info){
  if(!user_info) return false;
  const push = (user_info.notification_data || []).some(n => n.type === 'firebase_web');
  return push || user_info.telegramId != null;
}

function isIOS(){
  const iPadOS = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
  return /iPhone|iPad|iPod/.test(navigator.userAgent) || iPadOS;
}

// true se il sito e' aperto dall'icona sulla Home (PWA installata)
function isAppInstallata(){
  return window.matchMedia('(display-mode: standalone)').matches || navigator.standalone === true;
}

function findLastIndex(array, searchKey, searchValue) {
    
    var dividiInTrueFalse = []
    for (let i = 0; i < array.length; i++){
      if(array[i] !== undefined){
        dividiInTrueFalse.push(array[i].angelId === searchValue ? true : false)
      }
    }

    const countOccurrences = (arr, val) => arr.reduce((a, v) => (v === val ? a + 1 : a), 0);
    var occorrenze = countOccurrences(dividiInTrueFalse,true)
    
    const findLastIndex = dividiInTrueFalse.lastIndexOf(true)
    
    return {lastIndex:findLastIndex,occorrenze:occorrenze};

}


//Vecchia funziona di konnektive da eliminare a tempo debito
async function importOrder(dati){
  try{
    var token = localStorage.getItem('token');
    return await fetch(process.env.REACT_APP_APIADDRESS+"/payment/api/importOrder",{ 
      method: 'post', 
      headers: {
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+ token
      },
      body: JSON.stringify(dati)
    })
    .then(res => res.json())
    .then(response => {
      return response
    })
    .catch((err)=>{
      logToBackend("importOrder 1",{clickid:dati.clickid,error:err.message})
    })
  }catch(err){
    logToBackend("importOrder try catch",{clickid:dati.clickid,error:err.message})
  }
}


async function tryCharge(dati){
  var token = localStorage.getItem('token');
  try{

    return await fetch(process.env.REACT_APP_PAY+"/orders/tryCharge",{ 
      method: 'post', 
      headers: {
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+ token
      },
      body: JSON.stringify(dati)
    })
    .then(res => res.json())
    .then(response => {
      return response
    })
    .catch((err)=>{
      logToBackend("tryCharge 1",{clickid:dati.clickid,error:err.message})
    })
  }catch(err){
    logToBackend("tryCharge try catch",{clickid:dati.clickid,error:err.message})
  }
}


async function createToken(dati){
  var token = localStorage.getItem('token');
  try{

    return await fetch(process.env.REACT_APP_PAY+"/orders/createToken",{ 
      method: 'post', 
      headers: {
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+ token
      },
      body: JSON.stringify(dati)
    })
    .then(res => res.json())
    .then(response => {
      return response.token
    })
    .catch((err)=>{
      logToBackend("createToken 1",{clickid:dati.clickid,error:err.message})
    })
  }catch(err){
    logToBackend("createToken try catch",{clickid:dati.clickid,error:err.message})
  }
}




async function unsubUser(dati){
  var token = localStorage.getItem('token');
  return fetch(process.env.REACT_APP_PAY+"/orders/unsubUser",{ 
    method: 'post', 
    headers: {
      'Accept': 'application/json, text/plain, */*',
			'Content-Type': 'application/json',
      'Authorization': 'Bearer '+ token
    },
    body: JSON.stringify(dati)
  })
  .then(res => res.json())
  .then(response => {
     return response
  })
}

// -------------- VECCHIA FUNZIONE DI KONNEKTIVE DA CANCELLARE A TEMPO DEBITO
async function cancelOrder(dati){
  var token = localStorage.getItem('token');
  return fetch(process.env.REACT_APP_APIADDRESS+"/payment/api/cancelOrder",{ 
    method: 'post', 
    headers: {
      'Accept': 'application/json, text/plain, */*',
			'Content-Type': 'application/json',
      'Authorization': 'Bearer '+ token
    },
    body: JSON.stringify(dati)
  })
  .then(res => res.json())
  .then(response => {
     return response
  })
}


async function getRegionsByCountry(){
  const country = getCountry()
  try{
    return await fetch(process.env.REACT_APP_APIADDRESS+"/get/regions/"+country,{ 
      method: 'get', 
      headers: {
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json',
        'Clickid': localStorage.getItem('trackerId')
      }
    })
    .then(res => res.json())
    .then(response => {
       return response
    }).catch(err => logToBackend("getRegionsByCountry1",{country:country,error:err.message,trackerId : localStorage.getItem('trackerId')}) )
  }catch(err){
    logToBackend("getRegionsByCountry2",{country:country,error:err.message,trackerId : localStorage.getItem('trackerId')})
  }
  
}


async function getCitiesByCountry(){
  const country = getCountry()
  try{
    return await fetch(process.env.REACT_APP_APIADDRESS+"/get/cities/"+country,{ 
      method: 'get', 
      headers: {
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json',
        'Clickid': localStorage.getItem('trackerId')
      }
    })
    .then(res => res.json())
    .then(response => {
       return response
    }).catch(err => logToBackend("getCitiesByCountry1",{country:country,error:err.message,trackerId : localStorage.getItem('trackerId')}) )
  }catch(err){
    logToBackend("getCitiesByCountry2",{country:country,error:err.message,trackerId : localStorage.getItem('trackerId')})
  }
  
}


function importUpsale(dati){
  var token = localStorage.getItem('token');
  fetch(process.env.REACT_APP_APIADDRESS+"/payment/api/importUpsell",{ 
    method: 'post', 
    headers: {
      'Accept': 'application/json, text/plain, */*',
			'Content-Type': 'application/json',
      'Authorization': 'Bearer '+ token
    },
    body: JSON.stringify(dati)
  })
  .then(res => res.json())
  .then(response => {
     return response
  })
}


function importClick(kcampaign,pageType){
  var dati = {}
  dati.kcampaign = kcampaign
  dati.pageType = pageType
  var token = localStorage.getItem('token');
  fetch(process.env.REACT_APP_APIADDRESS+"/payment/api/importClick",{ 
    method: 'post', 
    headers: {
      'Accept': 'application/json, text/plain, */*',
			'Content-Type': 'application/json',
      'Authorization': 'Bearer '+ token
    },
    body: JSON.stringify(dati)
  })
}



function normalizeYear(year){
  // Century fix
  var YEARS_AHEAD = 20;
  if (year<100){
      var nowYear = new Date().getFullYear();
      year += Math.floor(nowYear/100)*100;
      if (year > nowYear + YEARS_AHEAD){
          year -= 100;
      } else if (year <= nowYear - 100 + YEARS_AHEAD) {
          year += 100;
      }
  }
  return year;
}

function isValidDate(date){


    const [month, year] = date.split('/').map(Number);
    if (!month || !year || month < 1 || month > 12) {
      return false
    }

    // Calcola l'anno completo
    const fullYear = 2000 + year;

    // Data attuale
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1; // Mesi da 0 a 11
    const currentYear = currentDate.getFullYear();

    // Verifica se la data è scaduta
  
    if (fullYear < currentYear || (fullYear === currentYear && month < currentMonth)) {
      return false
    } else {
      return true
    }
}


function formalizzaDataSignup(){
  var data = new Date(),
      dia  = data.getDate().toString(),
      diaF = (dia.length === 1) ? '0'+dia : dia,
      mes  = (data.getMonth()+1).toString(), //+1 pois no getMonth Janeiro começa com zero.
      mesF = (mes.length === 1) ? '0'+mes : mes,
      anoF = data.getFullYear(),
      ore = data.getHours().toString(),
      oreF = (ore.length === 1) ? '0'+ore : ore,
      minuti = data.getMinutes().toString(),
      minutiF = (minuti.length === 1) ? '0'+minuti : minuti,
      secondi = data.getSeconds().toString(),
      secondiF = (secondi.length === 1) ? '0'+secondi : secondi;
  return mesF+"/"+diaF+"/"+anoF+" "+oreF+":"+minutiF+":"+secondiF;
}



function rendiDataLeggibile(dataString) {
    if (!dataString) return '';
    const d = new Date(dataString);
    if (isNaN(d)) return dataString; // fallback se non parsabile
    const pad = n => n < 10 ? '0' + n : n;
    return `${pad(d.getDate())}/${pad(d.getMonth()+1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

function isQualityMessage(messageText) {
  if (!messageText || !messageText.trim()) {
    return false;
  }

  // Check for phone numbers (various formats)
  const phonePatterns = [
    /\b\+?\d[\d\s\-().]{7,}\d\b/, // Generic international format
    /\b\d{3}[\s\-.]?\d{3}[\s\-.]?\d{4}\b/, // US format: 123-456-7890
    /\b\d{2}[\s\-.]?\d{2}[\s\-.]?\d{2}[\s\-.]?\d{2}[\s\-.]?\d{2}\b/, // European: 12 34 56 78 90
    /\b\d{3}[\s\-.]?\d{2}[\s\-.]?\d{2}[\s\-.]?\d{2}[\s\-.]?\d{2}\b/, // Russia: 999 99 99 99 99
  ];

  for (const pattern of phonePatterns) {
    if (pattern.test(messageText)) {
      return false;
    }
  }

  // Social media keywords to block
  const socialPatterns = [
    // Facebook variants
    /\bfb\b/i,
    /\bfacebook\b/i,
    /\bmessenger\b/i,

    // Instagram variants
    /\big\b/i,
    /\bigs\b/i,
    /\binsta\b/i,
    /\binstagram\b/i,
    /\bigram\b/i,

    // Snapchat variants
    /\bsnap\b/i,
    /\bsnapchat\b/i,
    /\bsc\b/i,

    // WhatsApp variants
    /\bwhatsapp\b/i,
    /\bwa\b/i,
    /\bwtsp\b/i,
    /\bwapp\b/i,

    // Telegram variants
    /\btelegram\b/i,
    /\btg\b/i,
    /\btgram\b/i,
    /\btel\b/i,

    // TikTok variants
    /\btiktok\b/i,
    /\btik\b/i,
    /\btt\b/i,

    // Twitter/X variants
    /\btwitter\b/i,
    /\bx\.com\b/i,
    /\btwt\b/i,

    // Other social
    /\blinkedin\b/i,
    /\bdiscord\b/i,
    /\bskype\b/i,
    /\bzoom\b/i,
    /\bteams\b/i,
    /\bhangouts\b/i,
    /\bviber\b/i,
    /\bwechat\b/i,
    /\bline\b/i,
    /\bkik\b/i,
    /\btumblr\b/i,
    /\breddit\b/i,
    /\bvk\b/i,
    /\bok\.ru\b/i,
    /\bclassmates\b/i,
  ];

  for (const pattern of socialPatterns) {
    if (pattern.test(messageText)) {
      return false;
    }
  }

  // Words to exclude from count
  const excludeWords = [
    // Italian
    'il', 'lo', 'la', 'i', 'gli', 'le', 'un', 'uno', 'una', 'del', 'dello', 'della', 'dei', 'degli', 'delle',
    'al', 'allo', 'alla', 'ai', 'agli', 'alle', 'dal', 'dallo', 'dalla', 'dai', 'dagli', 'dalle',
    'nel', 'nello', 'nella', 'nei', 'negli', 'nelle', 'sul', 'sullo', 'sulla', 'sui', 'sugli', 'sulle',
    'di', 'a', 'da', 'in', 'con', 'su', 'per', 'tra', 'fra',
    'e', 'ed', 'o', 'od', 'ma', 'perché', 'poiché', 'affinché', 'mentre', 'quando', 'se', 'anche',
    'come', 'dove', 'che', 'cui', 'chi', 'cosa', 'quale', 'quanto',

    // English
    'the', 'an',
    'on', 'at', 'to', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 'during',
    'before', 'after', 'above', 'below', 'from', 'up', 'down', 'of', 'off', 'over', 'under', 'again',
    'further', 'then', 'once', 'by', 'until', 'via',
    'and', 'but', 'yet', 'so', 'nor', 'because', 'although', 'though', 'since', 'unless', 'while',
    'where', 'if', 'than', 'as', 'that', 'which', 'who', 'whom', 'whose', 'whatever', 'whenever',

    // Spanish
    'el', 'los', 'las', 'unos', 'unas', 'lo',
    'de', 'en', 'por', 'para', 'sin', 'sobre', 'entre', 'hasta', 'desde', 'hacia', 'durante',
    'mediante', 'según', 'ante', 'tras', 'bajo', 'al', 'del',
    'y', 'u', 'pero', 'aunque', 'porque', 'pues', 'como', 'cuando', 'donde', 'que', 'quien',
    'cual', 'cuanto', 'si', 'sea', 'sino',
  ];

  // Normalize: remove punctuation, lowercase
  const cleaned = messageText.replace(/[^\w\s]/gu, '');
  const words = cleaned
    .toLowerCase()
    .trim()
    .split(/\s+/)
    .filter(Boolean);

  let meaningfulCount = 0;

  for (const word of words) {
    if (!excludeWords.includes(word) && word.length > 0) {
      meaningfulCount++;
    }
  }

  return meaningfulCount >= 5;
} 